import { poModal } from './pomodal';

document.addEventListener('DOMContentLoaded', function () {
    // Calling Modal by Pdro
    if (document.querySelector('#content').classList.contains('archive-obra'))
        poModal();
});